module.exports = __webpack_public_path__ + "f606f44dc63ece688eae90b9a49e2456.svg";